import { apiConnector } from "./apiconnector";
const API_URL= process.env.REACT_APP_API_URL;
// Super Admin Dashboard APIs
export const getSuperAdminDashboard = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    if (filters.plantId) params.append('plantId', filters.plantId);
    if (filters.timeframe) params.append('timeframe', filters.timeframe);
    
    const response = await apiConnector('GET', `${API_URL}/super-admin/dashboard?${params}`);
    return response;
  } catch (error) {
    console.error('Error fetching super admin dashboard:', error);
    throw error;
  }
};

export const getPlantsForFilter = async () => {
  try {
    const response = await apiConnector('GET', `${API_URL}/super-admin/plants-list`);
    return response;
  } catch (error) {
    console.error('Error fetching plants for filter:', error);
    throw error;
  }
};

export const getConsolidatedObservations = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key]) params.append(key, filters[key]);
    });
    
    const response = await apiConnector('GET', `${API_URL}/super-admin/observations?${params}`);
    return response;
  } catch (error) {
    console.error('Error fetching consolidated observations:', error);
    throw error;
  }
};

export const getPlantComparison = async (params = {}) => {
  try {
    const searchParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key]) searchParams.append(key, params[key]);
    });
    
    const response = await apiConnector('GET', `${API_URL}/super-admin/plant-comparison?${searchParams}`);
    console.log("plant comparison",response)
    return response;
  } catch (error) {
    console.error('Error fetching plant comparison:', error);
    throw error;
  }
};